module.exports = __webpack_public_path__ + "img/sevilla.e252cbb9.jpg";